export default __webpack_public_path__ + "media/images/features/ana/example-aa5498387214de52664f2d4cd3df4064.png";